module.exports = "<div ng-if=\"$ctrl.productOptions\" \n     class=\"gridProductStyle\" \n     ui-grid-edit \n     ui-grid-row-edit\n     ui-grid-selection\n     ui-grid=\"$ctrl.productOptions\"></div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/product-dashboard/product-dashboard.html
// module id = 88
// module chunks = 0